// import React from "react";
// import "./App.css";
// import { Outlet, Route, Routes } from "react-router-dom";
// import Login from "./pages/Login";
// import Layout from "./components/Layout";
// import Dashboard from "./pages/dashboard";
// import DriverList from "./pages/driver";
// import Products from "./pages/product";
// import VendorList from "./pages/vendor";
// import VendorDetail from "./pages/vendor/VendorDetail";
// import DriverDetail from "./pages/driver/DriverDetail";
// import AddProduct from "./pages/product/AddProduct";
// import StockPoint from "./pages/stockPoint";
// import DPList from "./pages/DPList";
// import DPdetail from "./pages/DPList/DPdetail";

// const App = () => {
//   return (
//     <Routes>
//       <Route path="/" element={<Layout />}>
//         <Route index element={<Dashboard />} />
//         <Route path="driver-list" element={<Outlet />}>
//           <Route index element={<DriverList />} />
//           <Route path="driver-detail" element={<DriverDetail />} />
//         </Route>
//         <Route path="products" element={<Outlet />}>
//           <Route index element={<Products />} />
//           <Route path="add-product" element={<AddProduct />} />
//         </Route>
//         <Route path="vendors-list" element={<Outlet />}>
//           <Route index element={<VendorList />} />
//           <Route path="vendor-detail" element={<VendorDetail />} />
//         </Route>
//         <Route path="stock-point" element={<Outlet />}>
//           <Route index element={<StockPoint />} />
//         </Route>
//         <Route path="dp-list" element={<Outlet />}>
//           <Route index element={<DPList />} />
//           <Route path="dp-detail" element={<DPdetail />} />
//         </Route>
//       </Route>
//       <Route path="login" element={<Login />} />
//     </Routes>
//   );
// };

// export default App;

import React from "react";
import "./App.css";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/dashboard";
import DriverList from "./pages/driver";
import Products from "./pages/product";
import VendorList from "./pages/vendor";
import VendorDetail from "./pages/vendor/VendorDetail";
import DriverDetail from "./pages/driver/DriverDetail";
import AddProduct from "./pages/product/AddProduct";
import StockPoint from "./pages/stockPoint";
import DPList from "./pages/DPList";
import DPdetail from "./pages/DPList/DPdetail";
import GodownList from "./pages/godown";
import GodownDetail from "./pages/godown/GodownDetail";
import VehicleList from "./pages/vehicle";
import VehicleDetail from "./pages/vehicle/VehicleDetail";
import PromoList from "./pages/promocode";
import CustomerList from "./pages/customerlist";
import CustomerDetail from "./pages/customerlist/CustomerDetail";
import Orders from "./pages/orders";
import OrderDetail from "./pages/orders/OrderDetail";
import Receipt from "./pages/receipt";
import AddEditProduct from "./pages/product/AddProduct";
import ProductDetailPage from "./pages/product/ProductDetails";
import Inventory from "./pages/inventory";
import AddInventory from "./pages/inventory/AddInventory";
import Purchase from "./pages/purchase";
import AddPurchase from "./pages/purchase/AddPurchase";
import PurchaseDetail from "./pages/purchase/PurchaseDetail";
import AddVehicle from "./pages/vehicle/AddVehicle";
import Reports from "./pages/reports";
import LedgerReports from "./pages/reports/LedgerReports";
import SalesReports from "./pages/reports/SalesReports";
import PurchaseReports from "./pages/reports/PurchaseReports";
import ReceiptReport from "./pages/reports/ReceiptReports";
import AddDriver from "./pages/driver/AddDriver";
import Quotation from "./pages/Quotation";
import PurchaseOrder from "./pages/purchaseorder";
import QoutationDetails from "./pages/Quotation/QuotationDetails";
import PurchaseOrderDetail from "./pages/purchaseorder/PurchaseOrderDetails";
import BankList from "./pages/Banklist";
import AddBank from "./pages/Banklist/AddBank";
import BankDetails from "./pages/Banklist/BankDetails";
import BankReports from "./pages/reports/BankReports";
import AddCash from "./pages/Banklist/AddCash";
import DefectiveReturn from "./pages/DefectiveReturn";
import Support from "./pages/Support";
import DefectDetail from "./pages/DefectiveReturn/DefectDetail";
import TicketDetails from "./pages/Support/TicketDetails";
import PaymentRefund from "./pages/PaymentRefund";
import PaymenRefundDetails from "./pages/PaymentRefund/PaymenRefundDetails";
import Notification from "./pages/Notifications/Notification";
import AddDefective from "./pages/DefectiveReturn/AddDefective";
import EditDefectiveReturn from "./pages/DefectiveReturn/EditDefect";
import Credit from "./pages/Credit";
import CreditDetails from "./pages/Credit/CreditDetails";
import EquipmentMaster from "./pages/EquipmentMaster";
import EquipmentDetails from "./pages/EquipmentMaster/EquipmentDetails";
import OtpCollection from "./pages/OtpCollection";
import SecurityDetail from "./pages/SecurityDeposit/SecurityDetail";
import SecurityList from "./pages/SecurityDeposit/SecuritList";
import Coupon from "./pages/Coupon";
import Loan from "./pages/Loan/Loan";
import DailyRoster from "./pages/dashboard/DailyRoster";
import ListBlkLpg from "./pages/blkLpg/ListBlkLpg";
import AddBlkLpg from "./pages/blkLpg/AddBlkLpg";
import BlkLpgCustomer from "./pages/blkLpg/BlkLpgCustomer";

const App = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/notifications" element={<Notification />} />
          <Route index element={<Dashboard />} />
          <Route path="daily-roster" element={<DailyRoster />} />
          <Route path="driver-list" element={<Outlet />}>
            <Route index element={<DriverList />} />
            <Route path="add-driver" element={<AddDriver />} />
            <Route path="driver-detail" element={<DriverDetail />} />
          </Route>

          <Route path="godown-list" element={<Outlet />}>
            <Route index element={<GodownList />} />
            <Route path="godown-detail" element={<GodownDetail />} />
          </Route>
          <Route path="vehicle-list" element={<Outlet />}>
            <Route index element={<VehicleList />} />
            <Route path="/vehicle-list/add-vehicle" element={<AddVehicle />} />
            <Route path="vehicle-detail" element={<VehicleDetail />} />
          </Route>
          <Route path="products" element={<Outlet />}>
            <Route index element={<Products />} />
            <Route path="add-product" element={<AddProduct />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/products/edit/:id" element={<AddEditProduct />} />
          </Route>
          <Route path="blk-lpg" element={<Outlet />}>
            <Route index element={<ListBlkLpg />} />
            <Route path="add-blk-lpg" element={<AddBlkLpg />} />
            <Route path="customers" element={<BlkLpgCustomer />} />
          </Route>
          <Route path="inventory" element={<Outlet />}>
            <Route index element={<Inventory />} />
            <Route path="add-inventory" element={<AddInventory />} />
            <Route path="/inventory/edit/:id" element={<AddInventory />} />
          </Route>

          <Route path="otp" element={<Outlet />}>
            <Route index element={<OtpCollection />} />
          </Route>

          <Route path="coupon" element={<Outlet />}>
            <Route index element={<Coupon />} />
          </Route>

          <Route path="loan" element={<Outlet />}>
            <Route index element={<Loan />} />
          </Route>

          <Route path="banks" element={<Outlet />}>
            <Route index element={<BankList />} />
            <Route path="/banks/add-bank" element={<AddBank />} />
            <Route path="/banks/add-cash" element={<AddCash />} />
            <Route path="bank-detail/:id" element={<BankDetails />} />
          </Route>

          <Route path="quotation" element={<Outlet />}>
            <Route index element={<Quotation />} />
            <Route path="quotation-detail" element={<QoutationDetails />} />
          </Route>

          <Route path="purchase-order" element={<Outlet />}>
            <Route index element={<PurchaseOrder />} />
            <Route
              path="purchaseorder-detail"
              element={<PurchaseOrderDetail />}
            />
          </Route>

          <Route path="purchase" element={<Outlet />}>
            <Route index element={<Purchase />} />
            <Route path="add-purchase" element={<AddPurchase />} />
            <Route path="/purchase/detail/:id" element={<PurchaseDetail />} />
          </Route>
          <Route path="defective-return" element={<Outlet />}>
            <Route index element={<DefectiveReturn />} />
            <Route path="detail" element={<DefectDetail />} />
            <Route path="add" element={<AddDefective />} />
            <Route path="edit" element={<EditDefectiveReturn />} />
          </Route>

          <Route path="support" element={<Outlet />}>
            <Route index element={<Support />} />
            <Route path="ticket-detail" element={<TicketDetails />} />
          </Route>

          <Route path="payment-refund" element={<Outlet />}>
            <Route index element={<PaymentRefund />} />
            <Route
              path="payment-refund-detail"
              element={<PaymenRefundDetails />}
            />
          </Route>

          <Route path="vendors-list" element={<Outlet />}>
            <Route index element={<VendorList />} />
            <Route path="vendor-detail" element={<VendorDetail />} />
          </Route>
          <Route path="stock-point" element={<Outlet />}>
            <Route index element={<StockPoint />} />
          </Route>
          <Route path="dp-list" element={<Outlet />}>
            <Route index element={<DPList />} />
            <Route path="dp-detail" element={<DPdetail />} />
          </Route>
          <Route path="promo-list" element={<Outlet />}>
            <Route index element={<PromoList />} />
            <Route path="dp-detail" element={<DPdetail />} />
          </Route>
          <Route path="security-list" element={<Outlet />}>
            <Route index element={<SecurityList />} />
            <Route path="security-detail" element={<SecurityDetail />} />
          </Route>
          <Route path="customer-list" element={<Outlet />}>
            <Route index element={<CustomerList />} />
            <Route path="customer-detail" element={<CustomerDetail />} />
          </Route>
          <Route path="orders" element={<Outlet />}>
            <Route index element={<Orders />} />
            <Route path="order-detail" element={<OrderDetail />} />
          </Route>

          <Route path="credit" element={<Outlet />}>
            <Route index element={<Credit />} />
            <Route path="credit-detail" element={<CreditDetails />} />
          </Route>

          <Route path="equipment-master" element={<Outlet />}>
            <Route index element={<EquipmentMaster />} />
            <Route
              path="equipment-master-detail/:id"
              element={<EquipmentDetails />}
            />
          </Route>

          <Route path="receipt" element={<Outlet />}>
            <Route index element={<Receipt />} />
          </Route>
          <Route path="ledger-reports" element={<LedgerReports />} />
          <Route path="sales-reports" element={<SalesReports />} />
          <Route path="bank-reports" element={<BankReports />} />
          <Route path="purchase-reports" element={<PurchaseReports />} />
          <Route path="receipt-reports" element={<ReceiptReport />} />
          {/* <Route path="reports" element={<Outlet />}>
            <Route index element={<Reports />} />
          </Route> */}
        </Route>
        <Route
          path="login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
      </Routes>
    </>
  );
};

export default App;

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  return token ? children : <Navigate to="/login" replace />;
};

function PublicRoute({ children }) {
  const isAuthenticated = !!localStorage.getItem("authToken");
  return isAuthenticated ? <Navigate to="/" /> : children;
}

function PrivateRoute({ children }) {
  const isAuthenticated = !!localStorage.getItem("authToken");
  return isAuthenticated ? children : <Navigate to="/login" />;
}
